import React, { Fragment, useState } from "react";
import { Link } from 'react-router-dom';
import WebsiteHeader from "../../components/header/WebsiteHeader";
import WebsiteFooter from "../../components/Footer/WebsiteFooter";
import "../../assets/styles/category-homepages/paints-page.scss";
import offerart from "../../assets/images/individual-pages/Ro-Paints.png";
import offerart2 from "../../assets/images/individual-pages/Under70.png";
import offerart3 from "../../assets/images/individual-pages/UpTo&0.png";
import ProductList from "../../components/product/ProductList";
import RO01 from "../../assets/images/individual-pages/RO01.jpg";
import RO02 from "../../assets/images/individual-pages/RO02.jpg";
import RO03 from "../../assets/images/individual-pages/RO03.jpg";
import RO04 from "../../assets/images/individual-pages/RO04.jpg";
import catpic1 from "../../assets/images/individual-pages/InteriorPaints.png";
import catpic2 from "../../assets/images/individual-pages/ExteriorPAint.png";
import catpic3 from "../../assets/images/individual-pages/DecorativePaint.png";
import catpic4 from "../../assets/images/individual-pages/MetallicPaint.png";
import catpic5 from "../../assets/images/individual-pages/MarkingPaints.png";
import catpic6 from "../../assets/images/individual-pages/Pens&Markers.png";

import TopBanner1 from "../../assets/images/individual-pages/paints/Paints-Primers.jpg";
import TopBanner2 from "../../assets/images/individual-pages/paints/Epoxy.jpg";
import TopBanner3 from "../../assets/images/individual-pages/paints/Spray-Paints.jpg";

import five from "../../assets/images/individual-pages/paints/Acrylic-Paints.png";

import eight from "../../assets/images/individual-pages/paints/All-Purpose-Paint.png";
import four from "../../assets/images/individual-pages/paints/Primers-_-Stucco.png";
import nine from "../../assets/images/individual-pages/paints/Marking-Paints.png";
import three from "../../assets/images/individual-pages/paints/Exterior-Paint.png";
import one from "../../assets/images/individual-pages/paints/Rollers.png";
import seven from "../../assets/images/individual-pages/paints/Brushes.png";

import two from "../../assets/images/individual-pages/paints/Interior-Paint.png";
import ten from "../../assets/images/individual-pages/paints/Wood-Finishes.png";
import six from "../../assets/images/individual-pages/paints/Epoxy.png";





import offerbanner1 from "../../assets/images/individual-pages/paints/banners/Interior-Paints.jpg";
import offerbanner2 from "../../assets/images/individual-pages/paints/banners/Exterior-Paints.jpg";
import offerbanner3 from "../../assets/images/individual-pages/paints/banners/Wood-Finishes.jpg";
import offerbanner4 from "../../assets/images/individual-pages/paints/banners/Acrylic-Paints.jpg";
import offerbanner5 from "../../assets/images/individual-pages/paints/banners/Epoxy.jpg";
import offerbanner6 from "../../assets/images/individual-pages/paints/banners/Primers-_-Stucco.jpg";
import offerbanner7 from "../../assets/images/individual-pages/paints/banners/All-Purpose-Paint.jpg";
import offerbanner8 from "../../assets/images/individual-pages/paints/banners/Marking-Paints.jpg";
import offerbanner9 from "../../assets/images/individual-pages/paints/banners/Metallic-Paints.jpg";
import offerbanner10 from "../../assets/images/individual-pages/paints/banners/Glitter-Paints.jpg";
import offerbanner11 from "../../assets/images/individual-pages/paints/banners/Smoothing-Trowel.jpg";
import offerbanner12 from "../../assets/images/individual-pages/paints/banners/Grainer-Tool.jpg";


import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import { useEffect } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import { apiJson } from "../../Api";
SwiperCore.use([Pagination, Navigation]);
const PaintsPage = (props) => {

    const [section1, setSection1] = useState([]);
    const [section2, setSection2] = useState([]);
    const [section3, setSection3] = useState([]);
    const [section4, setSection4] = useState([]);
    const [section5, setSection5] = useState([]);
    const [section6, setSection6] = useState([]);

    useEffect(() => {
        window.document.title = "coffeesuq's Rust-oleum Paints";

        $("html, body").animate({ scrollTop: 0 }, "fast");



        apiJson.
            homepage.getSections(78, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection1(response.data);
                }
            });

        apiJson.
            homepage.getSections(79, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection2(response.data);
                }
            });

        apiJson.
            homepage.getSections(80, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection3(response.data);
                }
            });
        apiJson.
            homepage.getSections(81, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection4(response.data);
                }
            });
        apiJson.
            homepage.getSections(82, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection5(response.data);
                }
            });
        apiJson.
            homepage.getSections(83, props.countryId)
            .then(response => {
                if (response.success) {
                    // console.log(response.data);
                    // setProducts(response.data.products);
                    setSection6(response.data);
                }
            });


    }, []);
    return (
        <Fragment>
            <div className="product-home-page-desktop mx-auto paintspage">
                <WebsiteHeader />
                <div className="mypages-container">
                    <Swiper className="homepage-main-banner-swiper"
                        spaceBetween={0}
                        slidesPerView={1}
                        pagination={false}
                        navigation={true}
                    >
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=272&filter_by_category%5B%5D=439&filter_by_category%5B%5D=441&filter_by_category%5B%5D=442&filter_by_category%5B%5D=440&filter_by_category%5B%5D=443"
                            }}>
                                <img
                                    src={TopBanner1}
                                    className="img img-fluid"
                                    height="110px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=271"
                            }}>
                                <img
                                    src={TopBanner2}
                                    className="img img-fluid"
                                    height="110px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=273&filter_by_category%5B%5D=444&filter_by_category%5B%5D=445"
                            }}>
                                <img
                                    src={TopBanner3}
                                    className="img img-fluid"
                                    height="110px"
                                />
                            </Link>
                        </SwiperSlide>

                    </Swiper>




                    <div className="emptyspacer"></div>

                    <h2 className="sectiontitle-individualpage">Shop by Category</h2>
                    <div className="emptyspacer"></div>
                    <Swiper
                        spaceBetween={40}
                        slidesPerView={7}
                        pagination={false}
                        navigation={true}
                    >
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=423"
                            }}>
                                <img
                                    src={one}
                                    className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=439"
                            }}>
                                <img
                                    src={two} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=440"
                            }}>
                                <img
                                    src={three} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=442"
                            }}>
                                <img
                                    src={four} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=438"
                            }}>
                                <img
                                    src={five}
                                    className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=271"
                            }}>
                                <img
                                    src={six} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=424"
                            }}>
                                <img
                                    src={seven} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=445"
                            }}>
                                <img
                                    src={eight} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=444"
                            }}>
                                <img
                                    src={nine} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=274"
                            }}>
                                <img
                                    src={ten} className="img-img-fluid paintcat"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>

                    </Swiper>
                    <div className="emptyspacer"></div>
                    <div className="titlewrap">
                        <div className="emptyspacer"></div>
                        <h2 className="section-title lft catsec">{section1["title_" + props.language]}</h2>
                    </div>
                    <div className="surfacepat1">
                        <ProductList
                            type="product"
                            home={true}
                            products={section1.products}
                        />
                    </div>
                    {/* add here */}

                    <div className="row mt-4">
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=439"
                            }}>
                                <img
                                    src={offerbanner1}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=440"
                            }}>
                                <img
                                    src={offerbanner2}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="emptyspacer"></div>

                        <div className="titlewrap">
                            <div className="emptyspacer"></div>
                            <h2 className="section-title lft catsec">{section2["title_" + props.language]}</h2>
                        </div>
                        <div className="surfacepat1">
                            <ProductList
                                type="product"
                                home={true}
                                products={section2.products}
                            />
                        </div>

                        <div className="emptyspacer"></div>

                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=274"
                            }}>
                                <img
                                    src={offerbanner3}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=438"
                            }}>
                                <img
                                    src={offerbanner4}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div>
                            <div className="emptyspacer"></div>

                            <div className="titlewrap">
                                <h2 className="section-title lft catsec">{section3["title_" + props.language]}</h2>
                            </div>
                        </div>
                        <div className="surfacepat1">
                            <ProductList
                                type="product"
                                home={true}
                                products={section3.products}
                            />
                        </div>


                    </div>
                    <div className="emptyspacer"></div>
                    {/* mybrands */}
                    <h2 className="sectiontitle-individualpage">Shop by Brands</h2>
                    <div className="emptyspacer"></div>
                    <Swiper
                        spaceBetween={40}
                        slidesPerView={7}
                        pagination={false}
                        navigation={true}
                    >
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=42"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/hSZ6J8vxQ8pENansr4opLk.png"
                                    className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=45"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/8BBQmrEBYX1sD3jqfstdj6.png" className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=48"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/fwyPyYsDLWYNkLtUk8MS4E.png" className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=94"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/wuiWMpykzKEkkbizxXKKdW.png" className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=329"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/6wbn1oxKSWoA1wYVHjRgju.png"
                                    className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=64"
                            }}>
                                <img src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/jp81DcrwVpXgbTLFPj93Tw.png" className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide
                            onClick={(e) => e.preventDefault()}
                            key={1}
                        >
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_brand%5B%5D=56"
                            }}>
                                <img
                                    src="https://coffeesuq-production-s3-bucket.s3-me-south-1.amazonaws.com/media/images/5yEpHy771FyBamNNRqtbEB.png" className="img-img-fluid paintbrand"
                                    height="150px"
                                />
                            </Link>
                        </SwiperSlide>



                    </Swiper>

                    <div className="row mt-4">
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=271"
                            }}>
                                <img
                                    src={offerbanner5}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=442"
                            }}>
                                <img
                                    src={offerbanner6}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                    </div>
                    <div className="emptyspacer"></div>

                    <div className="titlewrap">
                        <h2 className="section-title lft catsec">{section4["title_" + props.language]}</h2>
                    </div>
                    <div className="surfacepat1">
                        <ProductList
                            type="product"
                            home={true}
                            products={section4.products}
                        />
                    </div>
                    <div className="row mt-4">
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=445"
                            }}>
                                <img
                                    src={offerbanner7}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=444"
                            }}>
                                <img
                                    src={offerbanner8}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                    </div>
                    <div className="emptyspacer"></div>

                    <div className="titlewrap">
                        <h2 className="section-title lft catsec">{section5["title_" + props.language]}</h2>
                    </div>
                    <div className="surfacepat1">
                        <ProductList
                            type="product"
                            home={true}
                            products={section5.products}
                        />
                    </div>

                    <div className="row mt-4">
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=437"
                            }}>
                                <img
                                    src={offerbanner9}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=436"
                            }}>
                                <img
                                    src={offerbanner10}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=427"
                            }}>
                                <img
                                    src={offerbanner11}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>
                        <div className="col-6 mt-2 mb-2">
                            <Link to={{
                                pathname: "/" + props.countryUrl +
                                    "-" + props.language + "/items/products",
                                search: "filter_by_category%5B%5D=428"
                            }}>
                                <img
                                    src={offerbanner12}
                                    alt="category"
                                    className="img img-fluid"
                                />
                            </Link>
                        </div>

                    </div>
                    <div className="emptyspacer"></div>

                    <div className="titlewrap">
                        <h2 className="section-title lft catsec">{section6["title_" + props.language]}</h2>
                    </div>
                    <div className="surfacepat1">
                        <ProductList
                            type="product"
                            home={true}
                            products={section6.products}
                        />
                    </div>
                    <div className="emptyspacer"></div>

                    <div className="titlewrap noclr">
                        <h2 className="sectiontitle-individualpage">Top Offers</h2></div>
                    <div className="catrow"
                        style={{
                            marginLeft: "0px !important",
                            marginRight: "0px !important",
                            width: "100%",
                        }}
                    >

                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 catbox">


                            <Link
                                to={{
                                    pathname: "/" + props.countryUrl +
                                        "-" + props.language +
                                        "/items/products",
                                    search: "?filter_by_brand%5B%5D=42&filter_by_price%5Bmax%5D=20"
                                }}
                            >

                                <div className="offerbg">
                                    <h2 className="offertitles">
                                        under<br></br>
                                        <span className="offerprice">
                                            aed 20
                                        </span>
                                    </h2>
                                    <img className="img-fluid topofferimg"
                                        src={offerart}
                                        alt="category"

                                    ></img>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 catbox">
                            <Link
                                to={{
                                    pathname: "/" + props.countryUrl +
                                        "-" + props.language +
                                        "/items/products",
                                    search: "?filter_by_brand%5B%5D=42&filter_by_price%5Bmax%5D=30"
                                }}
                            >

                                <div className="offerbg">
                                    <h2 className="offertitles">
                                        under<br></br>
                                        <span className="offerprice">
                                            aed 30
                                        </span>
                                    </h2>
                                    <img className="img-fluid topofferimg"
                                        src={offerart2}
                                        alt="category"

                                    ></img>
                                </div>
                            </Link>


                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 catbox">

                            <Link
                                to={{
                                    pathname: "/" + props.countryUrl +
                                        "-" + props.language +
                                        "/items/products",
                                    search: "?filter_by_brand%5B%5D=42&filter_by_price%5Bmax%5D=40"
                                }}
                            >

                                <div className="offerbg">
                                    <h2 className="offertitles">
                                        under<br></br>
                                        <span className="offerprice">
                                            aed 40
                                        </span>
                                    </h2>
                                    <img className="img-fluid topofferimg"
                                        src={offerart3}
                                        alt="category"

                                    ></img>
                                </div>
                            </Link>
                        </div>

                    </div>
                    <div className="emptyspacer"></div>


                    <div className="emptyspacer"></div>


                    <div className="category-content">
                        <h1>Paints</h1>
                        <p>Adding a touch of colour to your surroundings has a significant impact on your mood. We have introduced an endless range of paints and paint tools to help you infuse a more positive aura into your space. With a range of unique formulations, no surface in your home will look dull or lifeless. We have <Link to='items/products?filter_by_category%5B%5D=271'>epoxies</Link>, pre-preparation primers, <Link to='items/products?filter_by_category%5B%5D=274'>wood finishes</Link>, <Link to='items/products?filter_by_category%5B%5D=438'>acrylic paints</Link>, and decorative paints. Following the standards of safety, sustainability, and contemporary finishes, our range makes painting fun and easy.</p>

                        <p>We drive the world of architectural innovation with durable paints in a variety of shades, finishes, and consistencies. Combining an endless portfolio of products under one roof, we’ve created the largest platform for consumers. Fulfill all your construction, arts, and decoration needs with our one-stop shop that encloses all leading brands in one place. Purchase from us today to avail the best deals & discounts on your favourite paint supplies.</p>

                        <h2>Stock Up Our Bestseller Paint Products For Lasting Coats</h2>
                        <p>Every wall and surface tells a story of its own. You can enrich that story with the right shade and type of paint. We let you achieve your creative goals with the finest designs and colour combinations. Find interior and exterior paints to add a touch of sophistication and style to any space.</p>

                        <p>We offer both lightweight and heavy duty formulations that can withstand the tough conditions of commercial and industrial fields. No matter the type of coat you need, we have got you covered. Purchase from our paint categories to obtain excellent performance and unmatched reliability.</p>

                        <h2>Paint & Primers</h2>
                        <p>Transform your room with the best pastel and classic paint shades available in our collection. We combine standard formulations with a comprehensive list of adhesives, primers, and base coats, we offer a practical shopping experience. With our thick, dense, and lasting painting compounds, you can hide minor cracks, as well as major surface damage in just one coat.</p>

                        <h2>Specialized Wood Finishes</h2>
                        <p>Redefine your wooden furniture, cabinets, decor pieces, and much more with our selection of wood finishes. Available in an array of modern shades, our paints instantly uplift and transform wooden objects with a rich and original finish.</p>

                        <h2>Easy To Use Spray Paints</h2>
                        <p>Choose from an extensive collection of spray paints, designed for a versatile range of substrates. From metallic spray paints to road marking paints, everything is available in our store. Browse through our categories to find all types of peelable and acrylic paints for wood, metal, plastic, ceramic, concrete, and more.</p>

                        <h2>Best Arts & Crafts Supplies</h2>
                        <p>Let your artsy side flourish with our collection of creativity paints. Enjoy endless crafts with the finest quality glitter paints, acrylic paints, and paint markers. Easy to use, and safe for kids, our paints are perfect for general arts and decor projects.</p>

                        <h2>Epoxies</h2>
                        <p>Find functionally intelligent epoxy and polyurethane formulas for optimal surface protection. Ideal for flooring and building spaces, our durable and sturdy finishes comply with all safety standards. They create a protective coat on floors, while improving adherence for top coats. Purchase top-quality epoxy and polyurethane for all types of domestic, commercial, and industrial applications.</p>

                        <h2>Painting Tools & Brushes</h2>
                        <p>Find all the right painting tools and supplies here for an efficient painting job. From advanced paint products to standard wall painting tools, we have everything a DIY or professional painter may need. Purchase paint brush, rollers, trays, paint removers, and much more for an easy and hassle-free paint job.</p>

                        <p>Get the precise colour, hue, and finish you have been looking for. We are here to supply you with all the right paints and tools to make your painting tasks a bit less stressful. Purchase from our featured brands to attain excellent durability and unmatched performance.</p>

                        <h2>Find Best Rated Paint Shades & Tools For Your Convenience</h2>
                        <p>Choosing the right paint can alter the entire impression of a space. With us, you never have to worry about quality or performance, the only thing to take into account is the shade and type. With top-of-the-line decorative paints, epoxies, primers, and acrylics, we help re-energize interiors and exteriors.</p>

                        <p>Pick from countless finishes, including satin, gloss, matte, velvet, hammered, and much more, to achieve your desired texture. No matter the type and texture of the surface, our paints offer excellent hide and protection to keep all rust, chips, cracking, and damage out. Get inspired with an endless range of hues that reflect your personality and mood.</p>

                        <h2>What We Offer:</h2>
                        <ul>
                            <li>Spray paints with in-demand features that deliver a smooth finish and a refreshing look.</li>
                            <li>Eco-friendly wall and ceiling paints with no toxic chemicals or irritant compounds.</li>
                            <li>Long-lasting paints, featuring excellent resistance to UV and environmental damage.</li>
                            <li>Practical paint tools for a smooth and structured finish on flat and textured surfaces.</li>
                            <li>Specialized <Link to='items/products?filter_by_category%5B%5D=271'>base coats</Link>, decor paints, wood paints, and much more at reasonable rates.</li>
                            <li>Versatile applications, our paint formulations are designed for floors, walls, ceilings, metals, furniture, cabinetry, and much more.</li>
                        </ul>

                        <h2>Purchase From Top Rated Paint Brands At coffeesuq</h2>
                        <p>We house consumer-trusted paint brands to bring functional efficacy to homes. All our brand partners are known for their outstanding performance and durability. This means that you get only the best home painting materials with us! Shop stress-free with the leading UAE brands, all available under one roof.</p>

                        <h3>Rust Oleum</h3>
                        <p>Rust Oleum has no substitute when it comes to versatility. Combining a set of superior-quality spray paints, house paints, and painting materials from this brand, we’ve curated the most practical range of painting supplies.</p>

                        <h3>Jotun</h3>
                        <p>Jotun is a leading paint brand that is driven by creativity and innovation. This internationally recognized coating manufacturer brings you an endless array of domestic, commercial, and interior paints. Browse our range to buy their products.</p>

                        <h3>Testors</h3>
                        <p>A master in arts and crafts, Testors Crafts produces the best formulation for decor and interior projects. Let your inner artist thrive with the best quality acrylic, glitter, pen paints, and much more from Testors.</p>

                        <h3>Varathane</h3>
                        <p>Known for its top-rated wood finishes, Varathane never ceases to develop powerful formulations, featuring strong adherence for a variety of substrates. Purchase their products for effective maintenance and improved aesthetic appeal of wooden structures and other household materials.</p>

                        <h2>Shop Online With The Reliable Service Of coffeesuq</h2>
                        <p>We thrive on customer satisfaction, and that is why we ensure complete transparency in the shopping experience. Housing an endless array of merchandise, there is literally no product you won’t find in our store. Buy <Link to='items/products?filter_by_category%5B%5D=182&filter_by_category%5B%5D=195&filter_by_category%5B%5D=196&filter_by_category%5B%5D=197&filter_by_category%5B%5D=198&filter_by_category%5B%5D=203&filter_by_category%5B%5D=199&filter_by_category%5B%5D=200&filter_by_category%5B%5D=201&filter_by_category%5B%5D=202&filter_by_category%5B%5D=204'>building & construction materials</Link>, paints, <Link to='items/products?filter_by_category%5B%5D=183&filter_by_category%5B%5D=211&filter_by_category%5B%5D=306&filter_by_category%5B%5D=307&filter_by_category%5B%5D=308&filter_by_category%5B%5D=309&filter_by_category%5B%5D=464&filter_by_category%5B%5D=214&filter_by_category%5B%5D=206&filter_by_category%5B%5D=291&filter_by_category%5B%5D=207&filter_by_category%5B%5D=208&filter_by_category%5B%5D=209&filter_by_category%5B%5D=292&filter_by_category%5B%5D=293&filter_by_category%5B%5D=489&filter_by_category%5B%5D=205&filter_by_category%5B%5D=290&filter_by_category%5B%5D=289&filter_by_category%5B%5D=210&filter_by_category%5B%5D=295&filter_by_category%5B%5D=299&filter_by_category%5B%5D=300&filter_by_category%5B%5D=302&filter_by_category%5B%5D=304&filter_by_category%5B%5D=294&filter_by_category%5B%5D=296&filter_by_category%5B%5D=298&filter_by_category%5B%5D=303&filter_by_category%5B%5D=297&filter_by_category%5B%5D=301&filter_by_category%5B%5D=305&filter_by_category%5B%5D=212&filter_by_category%5B%5D=311&filter_by_category%5B%5D=452&filter_by_category%5B%5D=453&filter_by_category%5B%5D=451&filter_by_category%5B%5D=312&filter_by_category%5B%5D=313&filter_by_category%5B%5D=310&filter_by_category%5B%5D=449&filter_by_category%5B%5D=448&filter_by_category%5B%5D=450'>appliances</Link>, <Link to='items/products?filter_by_category%5B%5D=184'>cleaners</Link>, and much more online. Shop from coffeesuq to avail the best rates on the most sought-after products.</p>

                        <h3>Low Prices</h3>
                        <p>We follow a set of rules while determining the rates of each product, ensuring complete accessibility and affordability for all types of consumers.</p>

                        <h3>Fast Shipping</h3>
                        <p>There are no delays or order misplacements with us. Get your orders delivered to your doorstep in no time with the fastest shipping service in town.</p>

                        <h3>Free Consultations</h3>
                        <p>Reach out to our customer service reps for inspiration, consultation, or advice. Call or send an email to get an instant response to your queries.</p>

                        <p>You can rely on us to provide you with the best paints and tools for your home improvement projects. So, what are you waiting for? Add your favourites to your cart before they run out of stock!</p>


                    </div>









                </div>


                <div className="w-100">
                    <WebsiteFooter />
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        countryUrl: state.language.countryUrl,
        countryId: state.language.countryId,
        language: state.language.language,
    };
};


export default connect(mapStateToProps, null)(PaintsPage);


